import React, { useEffect, useMemo } from 'react'
import useUrlNavigation from '../../../../hooks/useUrlNavigation'
import useUrlParams from '../../../../hooks/useUrlParams'
import SecurityConfigDetails from '../../../../../CommonComponents/security-configuration/SecurityConfigDetails'
import { getSecurityConfigDetails, getSecurityConfiguration } from '../../../../../CommonComponents/security-configuration/helperFunctions'
import useScenario from '../../../../hooks/useScenario'
import useSecurityConfig from '../../../../hooks/useSecurityConfig'
import useSatellite from '../../../../hooks/useSatellite'
import { get_navigator_button_by_dashboard } from '../utils'
import './SecurityConfigurations.scss'
import { SCENARIO_DEPLOYMENT_TYPES } from '../../../../../simulate/constants'
import PlanningNavigation from '../PlanningNavigation'

const SecurityConfigurations = () => {
    const { scenario } = useScenario()
    const { tab_name, dashboard } = useUrlParams()
    const { navigate_to } = useUrlNavigation()
    const { selected_satellite } = useSatellite();
    const { securityConfig, setSecurityConfig } = useSecurityConfig()
    const deploymentType = useMemo(() => scenario?.scenarioDeploymentType, [scenario?.scenarioDeploymentType])
    const isValidateSummary =
        (scenario?.scenarioDeploymentType ?? '').toUpperCase() === SCENARIO_DEPLOYMENT_TYPES.VALIDATE &&
        dashboard === 'summary'
    const details = useMemo(() => getSecurityConfigDetails(securityConfig), [securityConfig])
    const satelliteId = useMemo(() => selected_satellite?.value?.satelliteId, [selected_satellite])

    const fetchSecurityConfiguration = async () => {
        if (!satelliteId) return
        const data = await getSecurityConfiguration(satelliteId)
        setSecurityConfig(data)
    }

    useEffect(() => {
        if (!satelliteId || securityConfig) return
        fetchSecurityConfiguration()
    }, [securityConfig, satelliteId])

    return (
        <div className='planning__container__body'>
            {deploymentType && (
                <div className='planning__container__header'>
                    <PlanningNavigation deploymentType={deploymentType} activeTab={tab_name} onNavigate={navigate_to} />
                </div>
            )}
            <div className='security__configurations__container'>
                <div className='__configurations__container__header'>
                    <div className='configurations__content__header__title'>
                        Security Keys
                    </div>
                </div>
                <div className='__configurations__container__body'>
                    <SecurityConfigDetails data={details} />
                </div>
            </div>
        </div>
    )
}

export default SecurityConfigurations